// extracted by mini-css-extract-plugin
export default {"infoCards":"InfoCards_infoCards__o0mSx","card":"InfoCards_card__aCQ9c"};